import React from "react";
import styled from "styled-components";

import PaywallAssetDiv from "../components/common/PaywallAssetDiv";
import Asset from "../components/asset";

const BoxContainer = styled.div`
  float: left;

  @media only screen and (max-width: 600px) {
    float: inherit;
  }
`;

const MultipleAssetsContainer = ({
  assets,
  branding,
  token,
  showPaywall,
  translate
}) =>
  assets.map((asset, i) => (
    <BoxContainer key={asset.item.id}>
      <PaywallAssetDiv
        id={`inplayer-${asset.item.id}`}
        className="inplayer-paywall"
      />
      <Asset
        branding={branding}
        token={token}
        data={asset}
        showPaywall={showPaywall}
        animationDelay={i / 9}
        translate={translate}
        descriptionCharLimit={120}
      />
    </BoxContainer>
  ));

export default MultipleAssetsContainer;
